module.exports = {
	"title": "Subject to change",
	"standfirst": "Do you hide your true self at work to win praise, promotion or even just acceptance? You’re not the only one. It’s called ‘covering’.",
	"miniTitle": "Covering",
	"miniDesc": "noun",
	"sectionIntro": "The act of changing your true self at work. This could mean:",
	"sections": [
		{
			"text": "Physical changes: your clothes, makeup or jewellery",
			"emoji": "👕"
		},
		{
			"text": "Verbal changes: your accent or your potty mouth",
			"emoji": "👄"
		},
		{
			"text": "Personality changes: your character or behaviour",
			"emoji": "🎭"
		}
	],
	"fact": "We asked 4,000 of you if you cover at work – and how. Here’s what you revealed…",
	"vizTitle": [
		{
			"text": "💼 New job, new you"
		},
		{
			"text": "Covering can start even before your first day on the job."
		}
	],
	"respondents": "% of respondents",
	"viz": [
		{
			"fact": "The majority of us hide our real personality during a job interview",
			"percentage": "62"
		},
		{
			"fact": "And we continue to cover when we start the new job",
			"percentage": "62"
		},
		{
			"fact": "It's not until we pass probation that most of us stop disguising our true selves",
			"percentage": "25"
		},
		{
			"fact": "Although the office party can make some of us want to put our disguises back on 🎉",
			"percentage": "45"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./copy/intro.txt
// module id = RtUu
// module chunks = 0